import request from '@/utils/request'

// 账号密码登录
export function LoginWithPassword(params: { username: string, password: string }) {
  // console.log('LoginWithPassword', params.username, params.password)
  return request({
    url: '/login/password',
    method: 'post',
    data: {
      username: params.username,
      password: params.password
    }
  })
}

// 微信登录
export function LoginWithWechatCode(params: { code: string }) {
  return request({
    url: '/login/wechat',
    method: 'post',
    data: {
      code: params.code
    }
  })
}

// 手机验证码登录
export function LoginWithPhoneCode(params: { phone: string, code: string }) {
  return request({
    url: '/login/phone',
    method: 'post',
    data: {
      phone: params.phone,
      code: params.code
    }
  })
}

// 获取用户全信息
export function GetUserInfo() {
  return request({
    url: '/user/all_info',
    method: 'get'
  })
}

// 获取用户信息
export function GetProfile() {
  return request({
    url: '/user/profile',
    method: 'get'
  })
}

// 更新用户名
export function SetUsername(params: { username: string }) {
  const data = {
    username: params.username
  }
  return request({
    url: '/user/profile',
    method: 'put',
    data
  })
}

// 绑定手机号
export function BindPhone(params: { phone: string, code: string }) {
  return request({
    url: '/user/bind/phone',
    method: 'post',
    data: {
      phone: params.phone,
      code: params.code
    }
  })
}

// 绑定微信号
export function BindWechat(params: { code: string }) {
  return request({
    url: '/user/bind/wechat',
    method: 'post',
    data: {
      code: params.code
    }
  })
}

// 切换租户
export function SwitchOrg(params: { orgId: number }) {
  return request({
    url: '/user/switch/org',
    method: 'post',
    data: {
      orgId: params.orgId
    }
  })
}

// 获取用户的角色列表
export function GetUserRoles() {
  return request({
    url: '/user/roles',
    method: 'get'
  })
}

// 获取用户的权限列表
export function GetUserPermissions() {
  return request({
    url: '/user/permissions',
    method: 'get'
  })
}

// 获取用户的部门列表
export function GetUserDepts() {
  return request({
    url: '/user/depts',
    method: 'get'
  })
}

// 获取用户的项目列表
export function GetUserProjects() {
  return request({
    url: '/user/projects',
    method: 'get'
  })
}

export function LogOut() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

// 修改密码
export function ChangePassword(params: { oldPassword: string, newPassword: string }) {
  return request({
    url: '/user/password',
    method: 'post',
    data: {
      oldPassword: params.oldPassword,
      newPassword: params.newPassword
    }
  })
}
